import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({});

export default theme;
